module.exports = __webpack_public_path__ + "static/media/cp1.f0a6475b.png";